import React, { useState } from 'react'

// redux
import { connect } from "react-redux";

// react router
import { useHistory } from "react-router-dom";

// bootstrap
import { Spinner } from "react-bootstrap";

// icons
import { BsEyeSlash, BsEye } from "react-icons/bs";

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react toastify
import { toast } from "react-toastify";

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";

import { addCustomer } from "utlis/Apis/Customers_API";

// common helpers
import { saveToLocalStorage } from 'utlis/helpers/Common/CommonHelperFunctions';

// actions
import { saveCurrentUserToStore } from 'redux/actions/actionAuth';
import { setGlobalLoading } from 'redux/actions/actionCommon';

// api
import { mergeCartItems } from 'utlis/Apis/Cart_API';

function StepRegister(props) {
    // props
    const {
        setGlobalLoading,
        tempOrderId,

        saveCurrentUserToStore,

        setSectionLoading,
        setRightMenuVisibility,
    } = props

    // const
    const history = useHistory();

    // states
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    // initial form values
    const initialFormValues = {
        firstName: "",
        lastName: "",
        email: '',
        phone: '',
        password: '',
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        firstName: Yup.string().required('This field is required'),
        lastName: Yup.string().required('This field is required'),
        email: Yup.string().email().required('This field is required'),
        phone: Yup.string().required('This field is required'),
        password: Yup.string()
            .required('This field is required')
            .min(8, "The password must be at least 8 characters long")
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, "Pasword must contain at least one uppercase letter, one lowercase letter, one number and one special character")
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            // showing btn loading
            setBtnDisabled(true)
            setSectionLoading(true);

            const customerInfo = {
                email_verified: "0",
                status: "1",
                email: values.email,
                mobile: values.phone,
                password: values.password,
                first_name: values.firstName,
                last_name: values.lastName,
                registration_source: "checkout"
            }

            // adding customer api
            addCustomer("", customerInfo).then(res => {
                const resData = res.data

                // if request is success
                if (resData?.success) {
                    // generating user details
                    const currentUser = {
                        loggedOn: new Date(),
                        canExpire: false,
                        email: values.email,
                        firstName: values.firstName,
                        lastName: values.lastName,
                        userId: resData.data.user_id,
                        userToken: resData.data.user_token,
                        tempOrderId: "",
                    };

                    // merging cart items with the already selected cart items by user
                    mergeCartItems(currentUser.userToken, {
                        customerId: currentUser?.userId,
                        from: tempOrderId,
                        to: currentUser?.tempOrderId
                    }).then(res => {
                        const resData = res.data

                        // hiding btn loading
                        setBtnDisabled(false)
                        setSectionLoading(false);

                        if (resData.success) {
                            // saving user to store
                            saveCurrentUserToStore(currentUser);
                            // then saving the user to the local storage
                            saveToLocalStorage("__uu_dd", JSON.stringify(currentUser));

                            setRightMenuVisibility(false)

                            // disabling global loading
                            setGlobalLoading(false)

                            window.location.reload()

                            // dismissing all the previous toasts first
                            toast.dismiss();

                            // showing the error message
                            toast.success("Account created successfully.", {
                                autoClose: 2500,
                                onClose: () => {
                                    // moving to checkout
                                    // moving to checkout
                                    // history.push({
                                    //     pathname: "/checkout",
                                    //     state: {
                                    //         allowNavigation: true
                                    //     }
                                    // })
                                }
                            });
                        }

                        // if request has some errors
                        if (resData.error) {
                        }
                    }).catch((err) => {
                        console.log(`${ERROR_WHILE__NAME} mergeCartItems `, err.message);

                        // dismissing all the previous toasts first
                        toast.dismiss();

                        // showing the error message
                        toast.error(UNKNOWN_ERROR_OCCURED, {
                            autoClose: 2500,
                            onClose: () => {
                                // hiding btn loading
                                setBtnDisabled(false)
                                setSectionLoading(false);
                            },
                        });
                    });
                }

                // if request is not success
                if (resData?.error) {
                    const emailError = resData?.message?.email ?? ""
                    const passwordError = resData?.message?.password ?? ""

                    // hiding btn loading
                    setBtnDisabled(false)
                    setSectionLoading(false);

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(emailError + " " + passwordError || UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500,
                        onClose: () => { },
                    });
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} addCustomer`, err.message);

                // hiding btn loading
                setBtnDisabled(false)
                setSectionLoading(false);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                });
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    // toggle password
    const togglePasswordDisplay = ev => {
        ev.preventDefault()
        setShowPassword(!showPassword)
    }


    return (
        <div className="frac">
            <div className="header-sec mb-3">
                <p className="head st-fs-19 st-fw-800 mb-2">New Customers</p>
                <p className="desc mb-0">Create a new account</p>
            </div>

            <div className="content-sec">
                <form
                    onSubmit={formik.handleSubmit}
                    noValidate
                    autoComplete="off">
                    <div className={`form-item mb-3 ${(formik.touched.firstName && formik.errors.firstName) ? "has-error" : ""}`}>
                        <label className="mb-2 st-fw-800">First Name <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                        <input
                            type="text"
                            className="form-control rounded-0"
                            {...formik.getFieldProps('firstName')}
                        />
                        {
                            (formik.touched.firstName && formik.errors.firstName) ? (
                                <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                    {formik.errors.firstName}
                                </div>
                            ) : null
                        }
                    </div>

                    <div className={`form-item mb-3 ${(formik.touched.lastName && formik.errors.lastName) ? "has-error" : ""}`}>
                        <label className="mb-2 st-fw-800">Last Name <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                        <input
                            type="text"
                            className="form-control rounded-0"
                            {...formik.getFieldProps('lastName')}
                        />
                        {
                            (formik.touched.lastName && formik.errors.lastName) ? (
                                <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                    {formik.errors.lastName}
                                </div>
                            ) : null
                        }
                    </div>

                    <div className={`form-item mb-3 ${(formik.touched.email && formik.errors.email) ? "has-error" : ""}`}>
                        <label className="mb-2 st-fw-800">Email <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                        <input
                            type="email"
                            className="form-control rounded-0"
                            {...formik.getFieldProps('email')}
                        />
                        {
                            (formik.touched.email && formik.errors.email) ? (
                                <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                    {formik.errors.email}
                                </div>
                            ) : null
                        }
                    </div>

                    <div className={`form-item mb-3 ${(formik.touched.phone && formik.errors.phone) ? "has-error" : ""}`}>
                        <label className="mb-2 st-fw-800">Phone <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                        <input
                            type="number"
                            className="form-control rounded-0"
                            {...formik.getFieldProps('phone')}
                        />
                        {
                            (formik.touched.phone && formik.errors.phone) ? (
                                <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                    {formik.errors.phone}
                                </div>
                            ) : null
                        }
                    </div>

                    <div className={`form-item position-relative password-field mb-3 ${(formik.touched.password && formik.errors.password) ? "has-error" : ""}`}>
                        <label className="mb-2 st-fw-800">Password <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                        <input
                            type={showPassword ? "text" : "password"}
                            className="form-control rounded-0"
                            {...formik.getFieldProps('password')}
                        />
                        <div className="icon position-absolute">
                            <div className="cursor-pointer" onClick={togglePasswordDisplay}>
                                {
                                    showPassword ? <BsEyeSlash /> : <BsEye />
                                }
                            </div>
                        </div>
                        {
                            (formik.touched.password && formik.errors.password) ? (
                                <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                    {formik.errors.password}
                                </div>
                            ) : null
                        }
                    </div>

                    <div className="btns pt-2">
                        <button
                            type="submit"
                            className="btn rounded-0 btn-block text-uppercase st-fw-800 default-btn"
                            disabled={btnDisabled}>
                            {
                                btnLoading ? (
                                    <Spinner animation="border" size="sm" />
                                ) : (
                                    <span>Create an account</span>
                                )
                            }
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}


const getDataFromStore = (state) => {
    return {
        tempOrderId: state.auth.tempOrderId,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        saveCurrentUserToStore: (user) => dispatch(saveCurrentUserToStore(user)),
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(StepRegister);